<template>
<div>
  <transition name="fade">
    <div v-if="!hasLoaded" class="rainbow-spinner">
      <md-progress-spinner class="spinner" :md-diameter="40" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </transition>
  <transition name="fade">
    <div class="md-layout" v-if="hasLoaded">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card header-color="blue">
          <template slot="header">
            <div class="card-icon">
              <md-icon>collections</md-icon>
            </div>
              <p class="category">Products</p>
              <h3 class="title">
                <animated-number
                  :value="dashboardData.NumberOfProducts"
                ></animated-number>
              </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>collections</md-icon>
              Number of products
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card header-color="rose">
          <template slot="header">
            <div class="card-icon">
              <md-icon>category</md-icon>
            </div>
            <p class="category">Categories</p>
            <h3 class="title">
              <animated-number
                :value="dashboardData.NumberOfCategories"
              ></animated-number>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>category</md-icon>
              Number of categories
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card header-color="green">
          <template slot="header">
            <div class="card-icon">
              <md-icon>alternate_email</md-icon>
            </div>
            <p class="category">Keywords</p>
            <h3 class="title">
              <animated-number
                :value="dashboardData.NumberOfKeywords"
              ></animated-number>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>alternate_email</md-icon>
              Number of keywords
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card header-color="warning">
          <template slot="header">
            <div class="card-icon">
              <md-icon>photo_camera</md-icon>
            </div>
            <p class="category">Photos</p>
            <h3 class="title">
              <animated-number
                :value="dashboardData.NumberOfPhotos"
              ></animated-number>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>photo_camera</md-icon>
              Number of photos
            </div>
          </template>
        </stats-card>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
// import AsyncWorldMap from "@/components/WorldMap/AsyncWorldMap.vue";
import axios from "axios";
// import moment from 'moment';

import {
  StatsCard,
  AnimatedNumber
  /* GlobalSalesCard,
  ChartCard,
  ProductCard,
  GlobalSalesTable*/
} from "@/components";

export default {
  components: {
    StatsCard,
    AnimatedNumber
    /* ProductCard,
    ChartCard,
    GlobalSalesCard,
    GlobalSalesTable,
    AsyncWorldMap */
  },
  mounted() {
    this.loadDashboardData();
  },
  computed: {
    hasLoaded () {
      return this.dashboardData !== null;
    }
  },
  methods: {
    loadDashboardData() {
      axios.get("api/Dashboard").then(response => {
        this.dashboardData = response.data;
      });
    }
  },
  data() {
    return {
      dashboardData: null
    };
  }
};
</script>
